import { render } from "./ResumePage.vue?vue&type=template&id=4bd84a6c&scoped=true"
import script from "./ResumePage.vue?vue&type=script&lang=js"
export * from "./ResumePage.vue?vue&type=script&lang=js"

import "./ResumePage.vue?vue&type=style&index=0&id=4bd84a6c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\aurel\\Desktop\\new-website\\portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bd84a6c"]])

export default __exports__